import React from 'react';
import IconButton, { IconButtonProps } from '@components/buttons/IconButton';

const ConfirmButton: React.FC<IconButtonProps> = (props) => (
  <IconButton {...props} icon="fa-check" />
);

export default ConfirmButton;
